const PHRASE = "SILENCE IS THE ONLY WEAPON — TRUST NO SIGNAL — EYES ONLY — PROTOCOL ZERO — ";

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="overflow-hidden border-y border-line bg-void py-5"
  >
    <div className="flex w-max animate-marquee whitespace-nowrap">
      {[0, 1, 2, 3].map((i) => (
        <span
          key={i}
          aria-hidden={i > 0}
          className="text-stroke-cyan px-4 font-mono text-5xl font-extrabold uppercase tracking-tight md:text-7xl"
        >
          {PHRASE}
        </span>
      ))}
    </div>
  </div>
);
